import { render, staticRenderFns } from "./Activate.vue?vue&type=template&id=6ced2762"
import script from "./Activate.vue?vue&type=script&lang=ts"
export * from "./Activate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ced2762')) {
      api.createRecord('6ced2762', component.options)
    } else {
      api.reload('6ced2762', component.options)
    }
    module.hot.accept("./Activate.vue?vue&type=template&id=6ced2762", function () {
      api.rerender('6ced2762', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account/Activate.vue"
export default component.exports